const doc = [({"da":({"js":({"admin":({"sheet_layouts":({"create_card":({"create_sheet_layout":"Opret arkopsætning"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;